import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineCalendar } from "react-icons/hi";
import { CustomButton, CustomButtonSize } from "../../../atoms/CustomButton";
import useAuth from "../../../../hooks/useAuth";
import { useAgendaAccess } from "../../../../hooks/agenda/useAgendaAccess";
import AppointmentModal from "./AppointmentModal";
import { AppointmentDraft, DraftAuthor } from "./appointmentDraft";

interface AddToAgendaButtonProps {
  getDraft: (author: DraftAuthor) => AppointmentDraft;
  size?: CustomButtonSize;
}

const AddToAgendaButton: React.FC<AddToAgendaButtonProps> = ({
  getDraft,
  size = "md",
}) => {
  const { t } = useTranslation();
  const { user, customer_identification: customerId } = useAuth();
  const { canCreate, managesOthers } = useAgendaAccess(
    customerId,
    user.entity_identification
  );
  const [draft, setDraft] = useState<AppointmentDraft | null>(null);

  if (!canCreate) return null;

  return (
    <>
      <CustomButton
        variant="secondary"
        size={size}
        icon={<HiOutlineCalendar size={16} />}
        title={t("agenda.actions.addToAgenda") as string}
        onClick={() =>
          setDraft(getDraft({ id: user.user_identification, managesOthers }))
        }
      />
      <AppointmentModal
        show={draft !== null}
        onClose={() => setDraft(null)}
        draft={draft ?? undefined}
      />
    </>
  );
};

export default AddToAgendaButton;
